module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_troendelag_neg.9f56e3d3.png";